export function removeSchemeFromHostName(hostName: string) {
    if (!hostName) {
        return ""
    }
    return hostName.replace(/(^\w+:|^)\/\//, "")
}
